module.exports = __webpack_public_path__ + "img/bandcamp.363c580c.svg";